import React from 'react';
import MainPage from '../../../composents/MainPage';
import DataTable from '../../../composents/DataTable';
import resources from '../../../services';

const title = 'Countries';
const headers = {
	icon: 'feather icon-command',
	title: title,
	description: 'track and manage all countries information',
};

export default function HyrdrodripPage() {
	return (
		<MainPage headers={headers} show_search>
			<DataTable
				column={[
					{
						label: 'Country name',
						field: 'name',
					},
					{
						label: 'Code 1',
						field: 'code_1',
					},
					{
						label: 'Code 2',
						field: 'code_2',
					},
					{
						label: 'Description',
						field: 'description',
					},
				]}
				resource={resources.country}
				title={title}
				link="/hydrodrip/countries"
			/>
		</MainPage>
	);
}
